import React from 'react';
import './ProfileProgress.css';
import { ImGift } from "react-icons/im";

const ProfileProgress = () => {
  return (
    <div className="profile-container">
      <h2>
        Complete your profile and get whopping 1000 points! &nbsp;
        <ImGift className="gift-icon" />
      </h2>

      <div className="progress-bar-container">
        <div className="progress-bar-fill">
          <span className="progress-label">50%</span>
        </div>
      </div>

      <p className="profile-description">
        The following general set of questions will be used to create your personal profile in order to provide you with the best future survey opportunities. Please take your time, answer carefully and truthfully.
      </p>
    </div>
  );
};

export default ProfileProgress;
